'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var styles = require('./styles-a9f2fe66.js');

var StyledMailTo = styled__default.a(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  font: normal 12px/24px ", ";\n  text-decoration: none;\n  color: ", ";\n\n  ", "\n  ", "\n  ", "\n"], ["\n  font: normal 12px/24px ", ";\n  text-decoration: none;\n  color: ", ";\n\n  ",
    "\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$sharedGreyDark;
}, function (_a) {
    var variant = _a.variant;
    return variant && "\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: inherit;\n    cursor: pointer;\n    border-radius: 4px;\n    border-width: 1px;\n    border-style: solid;\n    margin: 0;\n    text-align: center;\n    font-style: normal;\n    font-size: 14px;\n    line-height: 22px;\n  ";
}, function (_a) {
    var variant = _a.variant;
    return variant && styles.buttonVariantsStyles[variant];
}, function (_a) {
    var size = _a.size;
    return size && styles.buttonSizeStyles[size];
});
var templateObject_1;

exports.StyledMailTo = StyledMailTo;
